import { Mark } from './mark';

import styles from './logo-icon.module.css';

type LogoIconProps = {
  /**
   * Accessible name for the logo. Defaults to "NS Developer Portal".
   * Ignored when {@link LogoIconProps.decorative} is true.
   */
  'aria-label'?: string;
  className?: string;
  /**
   * Render as decorative when the icon sits inside another element that
   * already provides an accessible name (e.g. inside `LogoFull`).
   */
  decorative?: boolean;
  size?: number;
};

const DEFAULT_SIZE = 40;
const DEFAULT_LABEL = 'NS Developer Portal';

/**
 * The yellow tile + NS mark used as the collapsed-state logo in the Backstage
 * sidebar. Tile background and mark color are token-driven. The tile is yellow
 * with a navy mark in both light and dark mode, following Figma node 2661:16168.
 */
export function LogoIcon({
  'aria-label': ariaLabel = DEFAULT_LABEL,
  className,
  decorative = false,
  size = DEFAULT_SIZE,
}: LogoIconProps) {
  const markSize = Math.round(size * 0.8);
  const tileClassName = className ? `${styles.tile} ${className}` : styles.tile;

  const a11yProps = decorative
    ? { 'aria-hidden': true as const }
    : { 'aria-label': ariaLabel, role: 'img' };

  return (
    <span
      className={tileClassName}
      style={{ height: size, width: size }}
      {...a11yProps}
    >
      <Mark size={markSize} />
    </span>
  );
}
